import TabButtonIds from './TabButtonIds';

export default class DesignData {
  // ================================================================================================
  // properties
  // ================================================================================================
  static readonly DEFAULT_MAIN_COLOR = 'Pantone 349';

  static readonly DEFAULT_THIRD_COLOR = 'Pantone 102';

  static readonly DEFAULT_SECOND_COLOR = 'Black';

  static readonly DEFAULT_SELECTED_TAB = TabButtonIds.MAIN;

  static readonly NO_COLOR_SELECTED = 'None';

  static readonly REMOVE_GRADIENT_LABEL = 'Remove Gradient';
}
